import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import "./CompleteProfileYears.scss";

const CompleteProfileYears: React.FC = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
    register,
  } = useForm({});

  const navigate = useNavigate();

  const onSubmit = (data: any) => {
    console.log(data);
    navigate("/sign-up/location");
  };

  return (
    <>
      {/* <div className="sign-up-years__caption">
        <p className="sign-up-years__caption-title">Years of experience</p>
        <p className="sign-up-years__caption-subtitle">
          How many have you been in the sports world?
        </p>
      </div>

      <form className="sign-up-years__input" onSubmit={handleSubmit(onSubmit)}>
        <AcedInput
          placeHolder="Years"
          control={control}
          register={register("years")}
        ></AcedInput>

        <Button className="btn btn-primary ">Confirm</Button>
      </form> */}
    </>
  );
};

export default CompleteProfileYears;
